module.exports = __webpack_public_path__ + "static/media/boombox.9e3c5ef3.svg";